// extracted by mini-css-extract-plugin
module.exports = {"page":"page___2ePEn","container":"container___3Bs1u","backImg":"backImg___2ivRo","infoBox":"infoBox___19Tvh","titleInfo":"titleInfo___2L2_a"};